import React, { useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../../constants/general-constants";

am4core.useTheme(am4themes_animated);

export default function UtilisationFloorPlanDoughnut({ id, value, label, isDarkBackground }) {
  const chartRef = useRef(null);
  const labelRef = useRef(null);
  const displayedValueRef = useRef(0);   // last % shown
  const intervalRef = useRef(null);      // interval handle

  // Create chart once
  useEffect(() => {
    const chart = am4core.create(chartRef.current, am4charts.PieChart);

    chart.data = [
      { category: `${label} Utilised`, value },
      { category: "Remaining", value: 100 - value }
    ];

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "category";

    const borderColor = isDarkBackground ? SYSTEM_BLUE_BACKGROUND_LIGHT : "#fff";
    series.slices.template.stroke = am4core.color(borderColor);
    series.slices.template.strokeWidth = 2;
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;
    chart.innerRadius = am4core.percent(63);

    // Center label
    let chartLabel = chart.seriesContainer.createChild(am4core.Label);
    chartLabel.text = value.toFixed(0) + "%";
    chartLabel.horizontalCenter = "middle";
    chartLabel.verticalCenter = "middle";
    chartLabel.fontSize = 24;
    chartLabel.fontWeight = "bold";
    chartLabel.fill = isDarkBackground ? "#fff" : "#333";

    chartRef.current.chart = chart;
    labelRef.current = chartLabel;
    displayedValueRef.current = value; // initialise 0100

    return () => chart.dispose();
  }, []);

  // Animate label on value change
  useEffect(() => {
    const chart = chartRef.current?.chart;
    const chartLabel = labelRef.current;
    if (!chart || !chartLabel) return;

    chart.data = [
      { category: `${label} Utilised`, value },
      { category: "Remaining", value: 100 - value }
    ];

    let start = displayedValueRef.current;
    let end = Math.max(0, Math.min(100, Math.round(value))); // clamp 0100
    if (start === end) return;

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    let step = start < end ? 1 : -1;
    let current = start;

    intervalRef.current = setInterval(() => {
      current += step;
      chartLabel.text = current + "%";

      if (current === end) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        displayedValueRef.current = end;
      }
    }, 40);
  }, [value, label, isDarkBackground]);

  const titleStyle = {
    textAlign: "center",
    marginTop: "5px",
    fontSize: "12px",
    fontWeight: "bold",
    color: isDarkBackground ? "#fff" : "#000"
  };

  return (
    <div style={{ display: "flex", width: "100%", flexDirection: "column", paddingBottom: "20px" }}>
      <div id={id} ref={chartRef} style={{ width: "100%", height: "100%" }}></div>
      <div style={titleStyle}>{label}</div>
    </div>
  );
}
